import { Theme } from "@mui/material";

export const useModalStyles = (_theme: Theme) => ({
  paper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "600px",
    maxHeight: "90vh",
    minHeight: "562.5px",
    overflowY: "auto",
    borderRadius: "8px",
    padding: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  boxHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "100%",
  },
  boxTitle: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: 1.5,
  },
  divider: {
    marginX: -2,
  },
  boxFields: {
    paddingY: 1,
  },
  boxActions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 1,
  },
});
